if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      const buttonAddToCart = document.querySelectorAll('.quick-add__submit');
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        // this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const removeEmptyStatus = (cart) => {
        let cartContainer = cart;
        cartContainer.classList.contains('is-empty') ? cartContainer.classList.remove('is-empty') : null;
        const emptyContainer = cartContainer.querySelectorAll('.drawer__inner-empty');
        const drawerItemsInner = cartContainer.querySelector('.cart-items__container cart-drawer-items');
        drawerItemsInner ? drawerItemsInner.classList.remove('is-empty') : null;
        emptyContainer.forEach(content => content.remove());
      }

      const checkoutButton = document.querySelector('.cart__checkout-button');

      if (!window.location.pathname.includes('products')) {
        buttonAddToCart.forEach((btn) => {
            if ( btn.dataset.status == "available") {
              const btnQty =  btn.closest('product-form').querySelectorAll('.quantity__button');
              btnQty.forEach(qty => qty.setAttribute('disabled', ''));
            }
        });
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then( (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            // this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
       
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (window.location.pathname.includes('products')) {
              this.cart.renderContents(response);
            }
          }
          checkoutButton.removeAttribute('disabled');
          addLoading();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(async () => {
          this.submitButton.classList.remove('loading');
          if (window.location.pathname.includes('products')) {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            initializeUpsell();
            clearCart();
            openDiscountForm();
            window.drawerStatus = 1;
          }else{
            window.drawerStatus = 0;
            runEvents();
            setTimeout(async () => {
              buttonAddToCart.forEach((btn) => {
                const removePointEvent = (button) => {
                  button.style.pointerEvents = 'unset';
                  button.style.opacity = '1';
                }
                btn.dataset.status == "available"
                  ? removePointEvent(btn)
                  : null;

                  if ( btn.dataset.status == "available") {
                    const btnQty =  btn.closest('product-form').querySelectorAll('.quantity__button');
                    btnQty.forEach(qty => qty.removeAttribute('disabled'));
                  }
              });
            }, 250);
            buttonAddRefresh();
          }
          fetchCartBubble();
          removeLoading();
          removeEmptyStatus(this.cartDrawer);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
